<p-confirmDialog [style]="{ width: '50vw' }" />

<div class="flex gap-2 flex-column h-full">
  <div class="w-full gap-1 inline-flex align-items-center justify-content-between">
    <div
      class="flex align-items-center gap-2"
      style="flex: 1; min-width: 0"
    >
      @if (!assistantData.isFloating && !assistantData.isDocked) {
        <button
          class="p-button-secondary p-button-outlined no-outline fa-lg"
          style="border: none"
          pButton
          type="button"
          icon="fa fa-history"
          pTooltip="Historique"
          i18n-pTooltip="@@prompt_form_history_tooltip"
          (click)="historyToggled.emit()"
          label=""
        ></button>
      }
      @if (!assistantData.isFloating || floatingAssistantChatService.buttonsVisibility) {
        <div
          class="flex-1"
          style="min-width: 0"
        >
          <app-prompt-selector
            [disabled]="assistantData.genPending"
            (promptSelected)="onPromptSelected($event.node)"
            [selectedPrompt]="assistantData.selectedPrompt"
            [isFloattingAssistantChat]="assistantData.isFloating"
          />
        </div>
      }
    </div>
    <div class="flex align-items-center gap-2">
      @if (!assistantData.isFloating && !assistantData.isDocked) {
        <button
          class="p-button-secondary p-button-outlined no-outline fa-lg"
          style="border: none"
          type="button"
          pButton
          icon="fa fa-file"
          pTooltip="Fichiers uploadés"
          i18n-pTooltip="@@prompt_form_uploaded_files_tooltip"
          (click)="uploadedFileClicked.emit()"
          label=""
        ></button>
      }
      @if (!assistantData.isFloating || floatingAssistantChatService.buttonsVisibility) {
        <button
          class="p-button-secondary p-button-outlined no-outline fa-lg"
          style="border: none"
          type="button"
          pButton
          pTooltip="Réinitialiser"
          i18n-pTooltip="@@assistant_chat_clear_messages_button_tooltip"
          tooltipPosition="bottom"
          label=""
          (click)="reset()"
          icon="fa fa-undo"
        ></button>
        @if (this.assistantData.isFloating) {
          <button
            class="p-button-secondary p-button-outlined no-outline fa-lg"
            style="border: none"
            type="button"
            pButton
            pTooltip="Recharger la transcription"
            i18n-pTooltip="@@assistant_chat_reload_transcription_button_tooltip"
            tooltipPosition="bottom"
            label=""
            (click)="reloadFirstUserMessage()"
            [disabled]="floatingAssistantChatService.selectedMediaItems.length === 0"
            icon="fa fa-comments-o"
          ></button>
        }
        <button
          class="p-button-secondary p-button-outlined no-outline fa-lg"
          style="border: none"
          type="button"
          pButton
          pTooltip="Paramètres de la discussion"
          i18n-pTooltip="@@assistant_chat_settings_button_tooltip"
          tooltipPosition="bottom"
          label=""
          (click)="openSettings()"
          icon="fa fa-sliders"
          [disabled]="assistantData.genPending"
        ></button>
        @if (this.assistantData.isFloating) {
          <button
            class="p-button-secondary p-button-outlined no-outline fa-lg"
            style="border: none"
            type="button"
            pButton
            pTooltip="Activer la sélection de média"
            i18n-pTooltip="@@assistant_chat_media_selection_button_tooltip"
            tooltipPosition="bottom"
            label=""
            (click)="toggleMultiSelection()"
            icon="fa fa-plus-square-o"
            [disabled]="assistantData.genPending"
          ></button>
        }
      }
    </div>
  </div>
  @if (this.assistantData.isFloating && floatingAssistantChatService.selectionMode) {
    <app-drop-list />
  }
  <div
    class="flex-1 overflow-scroll"
    #scrollableRef
    (scroll)="onScroll()"
  >
    <markdown [data]="assistantData.summaryReport" />
    @for (message of assistantData.savedChat.messages; track message; let i = $index) {
      @if (message.role !== "system" && !message.hidden) {
        <app-chat-line
          [username]="message.role"
          [content]="message.content"
          [files]="message.files"
          (delete)="onDeleteMessage(i)"
        />
      }

      <!-- Per-message sources -->
      @if (hasSources(message)) {
        <hr class="divider" />
        <h5 i18n="@@prompts_assistant_grounding_sources">Sources</h5>
        <ul class="grounding-sources">
          @for (s of getSources(message); track trackByUri) {
            <li>
              <a
                [href]="s.uri"
                target="_blank"
                rel="noopener"
              >
                {{ s.title || s.uri }}
              </a>
            </li>
          }
        </ul>
      }

      <!-- Per-message Follow ups -->
      @if (hasFollowups(message)) {
        <hr class="divider" />
        <h5 i18n="@@prompts_assistant_follow_ups">Suggestions de suivi</h5>
        <ul class="query-pairs">
          @for (f of getFollowups(message); track trackByFollow) {
            <li>
              <a
                class="search-text"
                [href]="f.search"
                target="_blank"
                rel="noopener"
              >
                {{ f.follow | titlecase }}
              </a>
              <button
                class="google-chip"
                type="button"
                (click)="onSend({ prompt: f.follow, enableSearch: true, enableImageCreation: imageCreationEnabled })"
              >
                {{ f.follow | titlecase }}
              </button>
            </li>
          }
        </ul>
      }
    }
  </div>

  <div>
    <p-messages />
    <div class="mt-2 gap-2 flex flex-wrap align-items-center">
      @if (assistantData.collections.length > 0) {
        <span class="text-sm font-italic">
          <ng-container i18n="@@chat_input_collections_text">Emissions:</ng-container>
        </span>

        @for (collection of assistantData.collections; track collection) {
          <p-chip
            [label]="collection.name"
            [removable]="true"
            (onRemove)="removeCollection(collection.id)"
          />
        }
        <button
          class="p-button-secondary p-button-outlined no-outline text-2xl"
          style="border: none"
          type="button"
          pButton
          label=""
          icon="pi pi-plus"
          tooltipPosition="top"
          pTooltip="Ajouter des émissions à rechercher (Expérimental)"
          i18n-pTooltip="@@chat_input_collection_tooltip"
          (click)="openDialogToSelectCollections()"
        ></button>
      }
    </div>
    <app-chat-input
      (sendClick)="onSend($event)"
      (stopClick)="stopGenerating()"
      (textAreaInputChanged)="onUserInputChanged($event)"
      [canAddFiles]="true"
      [genPending]="assistantData.genPending"
      [textAreaInput]="assistantData.userInput"
      [showSearchToggle]="(showSearchToggleSubject | async) ?? false"
      [forceEnableSearch]="assistantData.searchGrounding"
      [modelTechnicalName]="assistantData.savedChat.model"
      [showImageCreationToggle]="(showImageCreationToggleSubject | async) ?? false"
    />
  </div>
</div>
